var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290.5485336220481 172.22829651215216",
    width: 871.6456008661444,
    height: 516.6848895364565,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      @font-face {\n        font-family: \"Virgil\";\n        src: url(\"https://excalidraw.com/Virgil.woff2\");\n      }\n      @font-face {\n        font-family: \"Cascadia\";\n        src: url(\"https://excalidraw.com/Cascadia.woff2\");\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.28803209496982 -15.577468366705943) rotate(315.65252120669544 0.6573253537817436 93.6688629138207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.22 31.22, 1.1 156.11, 1.31 187.34 M0 0 C0.22 31.22, 1.1 156.11, 1.31 187.34",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.82253513134492 77.54293595425588) rotate(315.65252120669544 96.62682700583537 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C32.21 0, 161.04 0, 193.25 0 M0 0 C32.21 0, 161.04 0, 193.25 0",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.28803209497164 -11.291862215795845) rotate(315.65252120669544 0.6573253537817436 93.6688629138207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.22 31.22, 1.1 156.11, 1.31 187.34 M0 0 C0.22 31.22, 1.1 156.11, 1.31 187.34",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.82253513134674 81.82854210516598) rotate(315.65252120669544 96.62682700583537 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C32.21 0, 161.04 0, 193.25 0 M0 0 C32.21 0, 161.04 0, 193.25 0",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.28803209496982 -7.006256064885747) rotate(315.65252120669544 0.6573253537817436 93.6688629138207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.22 31.22, 1.1 156.11, 1.31 187.34 M0 0 C0.22 31.22, 1.1 156.11, 1.31 187.34",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.82253513134492 86.11414825607608) rotate(315.65252120669544 96.62682700583537 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C32.21 0, 161.04 0, 193.25 0 M0 0 C32.21 0, 161.04 0, 193.25 0",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.28803209497164 -2.720649913975649) rotate(315.65252120669544 0.6573253537817436 93.6688629138207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.22 31.22, 1.1 156.11, 1.31 187.34 M0 0 C0.22 31.22, 1.1 156.11, 1.31 187.34",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.82253513134674 90.39975440698618) rotate(315.65252120669544 96.62682700583537 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C32.21 0, 161.04 0, 193.25 0 M0 0 C32.21 0, 161.04 0, 193.25 0",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.28803209496982 1.5649562369344494) rotate(315.65252120669544 0.6573253537817436 93.6688629138207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.22 31.22, 1.1 156.11, 1.31 187.34 M0 0 C0.22 31.22, 1.1 156.11, 1.31 187.34",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.82253513134492 94.68536055789627) rotate(315.65252120669544 96.62682700583537 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C32.21 0, 161.04 0, 193.25 0 M0 0 C32.21 0, 161.04 0, 193.25 0",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrDownWhite);
export default __webpack_public_path__ + "static/media/arr_down_white.ccb72dc88ecfd104ebf400e912b6865c.svg";
export { ForwardRef as ReactComponent };